// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iAtF","tabsBox":"styles_tabsBox__2AZwR","createButton":"styles_createButton__1usyg"};